import { Component, OnInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { DateUtility } from '../Utility/DateUtility';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ICellEditorAngularComp } from "ag-grid-angular/main";

@Component({
    selector: 'date-editor-cell',
    template: `
        <input type="text" class="form-control" style="padding: 0" restrict-input="date" mask-input="date" #headerText
         [minDate]="minRDDate" [maxDate]="maxRDDate" [appMinDate]="minRDDate" [appMaxDate]="maxRDDate" ngbDatepicker  #requestedDt="ngbDatepicker" firstDayOfWeek="7" (selectionDone)="onClick($event)"
        (click)="requestedDt.toggle()" [(ngModel)]="value"
    />
    `
})
export class BootstrapDatePickerComponent implements ICellEditorAngularComp {
    @ViewChild('headerText') headerText: ElementRef;
    private params: any;
    public value: any = {};
    minRDDate: NgbDateStruct;
    maxRDDate: NgbDateStruct;

    public selectedDate: Date = new Date();
    constructor(
        private dateUtil: DateUtility
    ) { }
    agInit(params: any): void {
        this.params = params;
        if (this.params.value == undefined || this.params.value == "mm/dd/yyyy") {
            this.value = this.params.value;
        }
        else {
            const parts = this.params.value.trim().split('/');
            this.value.month = parseInt(parts[0]);
            this.value.day = parseInt(parts[1]);
            this.value.year = parseInt(parts[2]);
        }
        setTimeout(() => this.headerText.nativeElement.focus(), 0);
        if (this.params.node.data.prostartDate !== undefined) {
            let prostartDate = this.params.node.data.prostartDate.trim().split('/');
            this.minRDDate = {
                month: parseInt(prostartDate[0]),
                day: parseInt(prostartDate[1]),
                year: parseInt(prostartDate[2])
            };
        }
        if (this.params.node.data.proendDate !== undefined) {
            let proendDate = this.params.node.data.proendDate.trim().split('/');
            this.maxRDDate = {
                month: parseInt(proendDate[0]),
                day: parseInt(proendDate[1]),
                year: parseInt(proendDate[2])
            };
        }
    }

    getValue(): any {
        if (this.value === undefined || this.value === "mm/dd/yyyy" || this.value === null || isNaN(this.value['day'])) {
            return '';
        } else {
            if (this.value['day'] < 10 && this.value['month'] < 10) {
                return `0${this.value['month']}/0${this.value['day']}/${this.value['year']}`;
            } else if (this.value['day'] < 10) {
                return `${this.value['month']}/0${this.value['day']}/${this.value['year']}`;
            } else if (this.value['month'] < 10) {
                return `0${this.value['month']}/${this.value['day']}/${this.value['year']}`;
            } else {
                return `${this.value['month']}/${this.value['day']}/${this.value['year']}`;
            }
        }
    }

    isPopup(): boolean {
        return true;
    }

    onClick(date: Date) {
        this.selectedDate = date;
        this.params.api.stopEditing();
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/ng-date-picker.component.ts